import { memo } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import NoDataToDisplay from "highcharts/modules/no-data-to-display";
import { statusColors } from "./chartData";

NoDataToDisplay(Highcharts);

const VehicleUsageChart = memo(({ data }) => {
  const categories = data?.map((item) => item.name);
  const values = data?.map((item) => ({
    name: item.name,
    y: item.value,
    color: {
      linearGradient: { x1: 0, x2: 0, y1: 0, y2: 1 },
      stops: statusColors[item.name],
    },
  }));

  const options = {
    chart: {
      type: "column",
    },
    title: {
      text: null,
    },
    xAxis: {
      categories,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    yAxis: {
      min: 0,
      title: null,
      labels: {
        style: {
          fontSize: "12px",
        },
      },
    },
    tooltip: {
      enabled: false,
    },
    series: [
      {
        name: "",
        data: values,
      },
    ],
    credits: {
      enabled: false,
    },
    exporting: {
      enabled: false,
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: true,
          align: "center",
          inside: false,
          formatter: function () {
            return `${this.y.toFixed(2)}%`;
          },
        },
      },
    },
    legend: {
      enabled: false,
    },
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
});

export default VehicleUsageChart;
